export const printlogicCustomerSyncLogTableConfig = {
  id: 'printlogic_customer_sync_log',
  name: 'Printlogic Customer Sync Log',
  apiEndpoint: '/api/admin/printlogic-customer-sync-log',
  readOnly: true,
  columns: [
    {
      key: 'started_at',
      label: 'Started',
      sortable: true
    },
    {
      key: 'trigger_source',
      label: 'Trigger',
      sortable: true
    },
    {
      key: 'triggered_by_username',
      label: 'Account',
      sortable: true,
      render: (value) => value || 'unknown'
    },
    {
      key: 'triggered_by_role',
      label: 'Role',
      sortable: true,
      render: (value) => value || '-'
    },
    {
      key: 'inserted_count',
      label: 'Added',
      sortable: true
    },
    {
      key: 'skipped_existing_count',
      label: 'Skipped',
      sortable: true
    },
    {
      key: 'failed_count',
      label: 'Failed',
      sortable: true
    },
    {
      key: 'message',
      label: 'Message',
      sortable: false
    }
  ],
  fields: []
};
